import { Button, Form, Input, Modal, Radio, Select, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import IntlMessage from '../../components/IntlMessage';
import orderApi from '../../api/order';
import operatorsApi from '../../api/operators';
import { debounce } from 'lodash';

const AssignOperatorModal = (props) => {
  const { open, onClose, onReload, currentData } = props;
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 999,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
  });
  const [operator, setOperator] = useState([]);
  const [form] = Form.useForm();

  const initialValues = {
    operator_id: currentData?.operator ? currentData.operator.id : '',
  };

  useEffect(() => {
    async function fetchData() {
      const res = await operatorsApi.getAll(filter);
      setOperator(res.data);
    }

    fetchData();
  }, [filter]);

  const onSearch = debounce((value) => {
    setFilter((filter) => {
      return {
        ...filter,
        keyword: value,
      };
    });
  }, 500);

  const handleCancel = () => {
    onClose();
  };

  const handleSubmit = async () => {
    setLoading(true);
    form
      .validateFields()
      .then(async (values) => {
        const data = { ...values };
        delete data.search;
        await orderApi
          .assignOperator(currentData.id, data)
          .then(() => {
            onReload();
            setLoading(false);
            handleCancel();
          })
          .catch((error) => {
            console.error(error);
            setLoading(false);
          });
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const onFinishFailed = (error) => {
    console.error(error);
  };

  return (
    <Modal
      title={<IntlMessage id="global.assign_operator" />}
      open={open}
      width={'80%'}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={onClose}>
          <IntlMessage id="global.cancel" />
        </Button>,
        <Button
          key="save"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
        >
          <IntlMessage id="global.save" />
        </Button>,
      ]}
    >
      <Form
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 16 }}
        form={form}
        layout="horizontal"
        labelAlign="left"
        onFinishFailed={onFinishFailed}
        onFinish={handleSubmit}
        initialValues={initialValues}
      >
        <Form.Item
          label={<IntlMessage id="global.operator" />}
          name="operator_id"
          rules={[
            {
              required: true,
              message: <IntlMessage id="global.requiredfield" />,
            },
          ]}
        >
          <Select showSearch onSearch={onSearch}>
            {operator?.length > 0 &&
              operator?.map((item) => {
                return (
                  <Select.Option key={item.id} value={item.id}>
                    {item.title}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AssignOperatorModal;
